const validate = {
  rules: {
    // estado_id: {
    //   required: true,
    // },
    descricao: {
      required: true,
    },
  },
  messages: {
    //estado_id: "O estado é obrigatório.",
    descricao: "A descrição é obrigatório.",
  },
};

export default validate;
